import React from "react";

const Delete = () => {
  return (
    <svg width="16" height="16" role="img" aria-label="Delete">
        <path fill="#E37276" fillRule="evenodd" d="M5 2C5 1.034 5.784.25 6.75.25h2.5C10.216.25 11 1.034 11 2v1.5h3.25a.75.75 0 0 1 0 1.5H14a.74.74 0 0 1-.004.078l-.862 8.21a2.75 2.75 0 0 1-2.735 2.462H5.6a2.75 2.75 0 0 1-2.735-2.463l-.862-8.209A.759.759 0 0 1 2 5h-.25a.75.75 0 0 1 0-1.5H5V2ZM3.504 5l.854 8.13A1.25 1.25 0 0 0 5.6 14.25h4.798a1.25 1.25 0 0 0 1.243-1.12L12.496 5H3.504ZM9.5 2v1.5h-3V2a.25.25 0 0 1 .25-.25h2.5A.25.25 0 0 1 9.5 2Zm-3 4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75Zm3.75.75a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0v-4.5Z" clipRule="evenodd"/>
    </svg>
  );
};

export default Delete;
